import React from "react";
import ConnectionProfile from "./ConnectionProfile";
import { ProgramConnectionContainer } from "./styles";

function ProgramConnection() {
  return <ProgramConnectionContainer>
    <ConnectionProfile/>
  </ProgramConnectionContainer>;
}
export default ProgramConnection;